import "./movingBackground.css";

export default function MovingBackground() {
    return (
        <div id="galeria">
            <div className="mosaico ">$645978</div>
            <div className="mosaico  text-white">$12756</div>
            <div className="mosaico ">$20</div>
            <div className="mosaico ">$3158</div>
            <div className="mosaico  text-white">$2356756</div>
            <div className="mosaico ">$354</div>
            <div className="mosaico ">$31597</div>
        </div>
    );
}